<script>
export default {
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    nomor: {
      type: [Number, String],
      default: null,
    },
  },
  emits: ["mulai"],
};
</script>

<template>
  <div class="mym-jadwal-card">
    <div class="mym-jadwal-card-header">
      <div class="mym-jadwal-header-info">
        <div class="mym-jadwal-icon-box">
          <i class="far fa-file-alt"></i>
        </div>
        <div class="min-w-0">
          <div class="mym-jadwal-kode">{{ rowData?.kode_tes || "-" }}</div>
          <div class="mym-jadwal-pelaksanaan">
            {{ rowData?.pelaksanaan || "-" }}
          </div>
        </div>
      </div>

      <span v-if="nomor !== null" class="mym-jadwal-no">#{{ nomor }}</span>
    </div>

    <p class="mym-jadwal-desc">{{ rowData?.keterangan || "-" }}</p>

    <div class="mym-jadwal-dates">
      <div class="mym-jadwal-date-chip mym-jadwal-date-start">
        <i class="far fa-calendar-check"></i>
        <div class="mym-jadwal-date-text">
          <span class="mym-jadwal-date-label">Mulai</span>
          <span class="mym-jadwal-date-value">{{
            rowData?.tanggal_mulai || "-"
          }}</span>
        </div>
      </div>

      <div class="mym-jadwal-date-chip mym-jadwal-date-end">
        <i class="far fa-calendar-times"></i>
        <div class="mym-jadwal-date-text">
          <span class="mym-jadwal-date-label">Selesai</span>
          <span class="mym-jadwal-date-value">{{
            rowData?.tanggal_selesai || "-"
          }}</span>
        </div>
      </div>
    </div>

    <div class="mym-jadwal-footer">
      <button
        type="button"
        class="mym-jadwal-btn-mulai"
        @click="$emit('mulai', rowData)"
      >
        <i class="fa fa-play"></i> Mulai
      </button>
    </div>
  </div>
</template>
